module.exports = __webpack_public_path__ + "static/media/linkIcon.dc2746f8.png~";